type InputLabelProps = {
  label: React.ReactNode;
  htmlFor: string;
};

export function InputLabel({ label, htmlFor }: InputLabelProps) {
  return (
    <label className="text-sm text-slate-600 font-semibold block pb-2" htmlFor={htmlFor}>
      {label}
    </label>
  );
}
